import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import TaticalAnalysisMobile from "./TaticalAnalysisMobile";
import TaticalAnalysisDesktop from "./TaticalAnalysisDesktop";

function TaticalAnalysis({ config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <TaticalAnalysisMobile config={config} />
  ) : (
    <TaticalAnalysisDesktop config={config} />
  );
}

TaticalAnalysis.defaultProps = {
  app: null,
  config: {},
};

TaticalAnalysis.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default TaticalAnalysis;
